import { useState, useEffect, useCallback } from 'react';

import styled from '@emotion/styled';

import { NEXT_PUBLIC_MOCK_ENABLED } from '../../../../../shared/configs/config';

const Iframe = styled.iframe`
  width: 100%;
`;

interface Props {
  contentProductNo: number;
}

export default function ProductReviewContents({ contentProductNo }: Props) {
  const defaultHeight = 410;
  const [iframeHeight, setIframeHeight] = useState(defaultHeight);

  const handleWindowMessage = useCallback((e: MessageEvent) => {

    if (typeof e.data !== 'number') {
      return;
    }
    const iHeight = defaultHeight > e.data ? defaultHeight : e.data;
    setIframeHeight(iHeight);
  }, []);

  useEffect(() => {
    window.addEventListener('message', handleWindowMessage );
    return () => {
      window.removeEventListener('message', handleWindowMessage);
    };
  }, [handleWindowMessage]);

  // NOTE: Lighthouse-CI 임시 처리 - 추후 Iframe Wrapper Component 추가
  if (NEXT_PUBLIC_MOCK_ENABLED) {
    return null;
  }

  return (
    <Iframe
      src={`/shop/goods/goods_review_list.php?goodsno=${contentProductNo}`}
      frameBorder="0"
      height={iframeHeight}
    />
  );
}
